import script from "./VirtualButtonSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualButtonSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./VirtualButtonSettingPage.vue?vue&type=style&index=0&id=763e78db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763e78db"]])

export default __exports__